import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {L10nModule} from '../translate';
import {MultiselectDropdownMenuModule} from './multiselect-dropdown-menu';
import {MultiselectComponent} from './multiselect.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        L10nModule,
        MultiselectDropdownMenuModule
    ],
    declarations: [
        MultiselectComponent
    ],
    exports: [
        MultiselectComponent
    ]
})
export class MultiselectModule {}
